import * as React from "react";
const SvgAudit = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 9, r: 5, stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 6V9.5L9.5 11", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("line", { x1: 8, y1: 3.5, x2: 8, y2: 2.5, stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("line", { x1: 5.45862, y1: 2, x2: 10.5414, y2: 2, stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgAudit;
